/**
 * // Class Obj: Feature対象のDOMを判定し、必要なモジュールだけ読み込む
 */
export class FeatureModuleLoader
{
  private readonly mRoot: ParentNode;

  /**
   * // Constructor: Feature対象DOMを検索する基準要素を受け取る
   *
   * @param   {ParentNode}  root_node  Feature対象DOMを検索する標準要素
   */
  constructor(root_node: ParentNode = document)
  {
    this.mRoot = root_node;
  }

  /**
   * // Method: 指定したFeature対象DOMが存在するか鑑定
   *
   * @param selector Feature対象DOMのセレクタ
   */
  public hasTarget(selector: string): boolean
  {
    return this.mRoot.querySelector(selector) !== null;
  }

  /**
   * // Method: 対象DOMが存在する場合だけFeatureモジュールだけ読み込む
   *
   * @param {string} selector Feature対象DOMのセレクタ
   * @param {Promise<void><Promise><void>}  loader Featureモジュールの読み込み・接続処理
   *
   */
  public async load(selector: string, loader: () => Promise<void>): Promise<void>
  {
    if (!this.hasTarget(selector))
    {
      return;
    }

    await loader();
  }
}